import React, { useState, useEffect } from 'react';
import { logEvent } from '../../utils/logger';

const Topbar = () => {
  const featureKey = 'featureDismissedKey';
  const currentFeatureVersion = 12;
  const [isVisible, setIsVisible] = useState(false);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    const checkVisibility = () => {
      const dismissedVersionString = localStorage.getItem(featureKey);
      const dismissedVersion = dismissedVersionString ? parseInt(dismissedVersionString, 10) : 0;
      if (dismissedVersion !== currentFeatureVersion) {
        setIsVisible(true);
      }
    };

    if(!isActive) return

    checkVisibility();
  }, []);

  const handleDismiss = () => {
    logEvent('Topbar Dismissed Clicked');
    localStorage.setItem(featureKey, currentFeatureVersion.toString());
    setIsVisible(false);
  };

  if (!isVisible || !isActive) {
    return null;
  }

  return (
    <div className="flex justify-between items-center p-4 bg-[#E8E5F1] w-full z-40">
      <div className="flex-1 text-center">
        <p className="font-medium text-black opacity-90 text-ba text-sm md:text-lg">
          📧 Reach Thousands of Podcasters with Our Newsletter Services:         
          <span className="font-bold text-[#27004F] ml-1">
            <a href="/advertise-in-newsletter" target="_blank" rel="noopener noreferrer" className="underline hover:no-underline">Advertise Products</a>
          </span>
          <span className="text-black mx-2">|</span>
          <span className="font-bold text-[#27004F]">
            <a href="/get-booked-on-podcasts" target="_blank" rel="noopener noreferrer" className="underline hover:no-underline">Get Booked as Guest</a>
          </span>
        </p>
      </div>
      <div>
        <button onClick={handleDismiss} className="text-xs text-[#27004F] font-bold bg-[#FD9B79] py-1 px-3 rounded">
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default Topbar;